"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(url) {
    if (url) {
        const oldUrlRegExp = new RegExp(process.env.OLD_URL, 'g');
        return url.replace(oldUrlRegExp, process.env.CDN_URL);
    }
    else
        return '';
}
exports.default = default_1;
